import styled from 'styled-components';
import { compose, add } from 'ramda';
import { Button } from '../../shared/components/button';
import { themeSize } from '../../theme/getters';
import { media } from '../../theme/media';

export const Container = styled.div`
  padding-top: ${compose(
    add(56),
    themeSize('header')
  )}px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
`;

export const ContinueButton = styled(Button)`
  width: 100%;
  text-transform: uppercase;
  max-width: 700px;
  margin: 48px auto 80px;
`;

export const Content = styled.div`
  flex-grow: 1;
`;

export const ButtonWrapper = styled.div`
  padding: 0 ${themeSize('contentPadding')}px;

  ${media.tablet`
    padding: 0;
  `}
`;
